<template>
  <SfCarousel
    v-if="slides.length"
    class="carousel"
    :settings="{
      autoplay: 5000,
      perView: 1,
      breakpoints: {
        1023: {
          perView: 1,
        },
      },
    }"
  >
    <SfCarouselItem v-for="slide in slides" :key="slide.Id" class="carousel__item">
      <Banner
        :maxHeight="maxHeight"
        :picture="slide.PictureUrl ? pictureUrlPath(slide.PictureUrl) : null"
        background="#fff"
        :fullWidth="slide.FullWidth"
        :description="slide.Description"
        :buttonText="slide.ButtonText"
        :link="slide.Link"
      />
    </SfCarouselItem>
  </SfCarousel>
</template>

<script>
import { mapActions } from 'vuex';
import { SfCarousel } from '@storefront-ui/vue';
import Banner from './Banner.vue';
import config from '../mixins/config';

export default {
  name: 'Slider',
  mixins: [config],
  components: {
    SfCarousel,
    Banner,
  },
  props: {
    type: {
      type: String,
      default: 'HomePage',
    },
    maxHeight: {
      type: String,
      default: '32Opx',
    },
  },
  data() {
    return {
      slides: [],
      types: {
        HomePage: 0,
        Category: 1,
        Manufacturer: 2,
        LoginPage: 3,
      },
    };
  },
  created() {
    this.fetchSlider(this.types[this.type]).then(data => {
      this.slides = data;
    });
  },
  methods: {
    ...mapActions({
      fetchSlider: 'core/fetchSlider',
    }),
  },
};
</script>

<style lang="scss">
@import '~@storefront-ui/shared/styles/_helpers';
@import 'src/scss/_breakpoint';

.sf-carousel {
  .sf-carousel__controls {
    z-index: 1;
    pointer-events: none;
  }

  .sf-carousel__slides {
    align-items: center;
  }

  .sf-arrow--long:hover {
    transform: scale(1);
  }

  .banner-image {
    display: flex;
    align-items: center;
  }

  .banner-image:not(.banner-image-full-width) img {
    max-width: 100%;
    width: auto;
  }

  .sf-arrow {
    pointer-events: auto;
    background: var(--_c-blue-primary);
    padding: 20px 20px;
    width: 0;
    &:hover {
      background: rgba(#1c69d4, 0.75);
    }

    &__icon {
      position: relative;
      display: flex;
      align-items: center;
      left: -5px;
    }

    &__icon::before {
      content: '';
      display: inline-block;
      width: 15px;
      height: 15px;
      border-bottom: 3px solid var(--c-white);
      border-left: 3px solid var(--c-white);
      position: absolute;
      transform: rotate(45deg);
    }

    svg {
      display: none;
    }
  }

  .sf-arrow--right .sf-arrow__icon {
    left: 5px;
  }
}
</style>
